import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";

import { useEffect, useState } from "react";
import { useLocation,useHistory } from "react-router-dom";


import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Admin from "../../components/auth/Admin";
import Staff from "../../actions/staff";
import { Grid, TableBody, TableCell, TableRow, Typography } from "@mui/material";



const headCells = [
  { id: "name", label: "Role Name" },
  { id: "description", label: "Description" },
  { id: "permisstion", label: "Persmisstion"},
];

const StaffDetailPage = () => {
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  const { NotifyMessage, notify, setNotify } = Notify();
  const {viewStaff } = Staff();

  const [staffRoles, setStaffsRoles] = useState([]);
  const [staff, setStaff] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getStaffData();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getStaffData = () => {
    viewStaff(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.staf) {
        setStaff(data.staf)
        setStaffsRoles(data.staf.staffRoles)
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staffRoles, headCells, filterFn);
    const history = useHistory();

  return (
    <Layout>
      <Admin>
        <div className="card">
        <Typography variant="h6">
        <ArrowBackIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push("/staffs");
          }}
        />
        <span style={{ marginLeft: "6px" }}>Staff Detail</span>
      </Typography>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  {" "}
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.role.name}</TableCell>
                            <TableCell>{item.role.description}</TableCell>
                            <TableCell>{item.role.rolePermissions?.length}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default StaffDetailPage;
